import React, { useState, useEffect } from 'react';
import { useAlert } from 'react-alert';
import { useTranslation } from 'react-i18next';
import AffiliationsPresentational from './AffiliationsPresentational';
import { list as listProfiles } from '../../../lib/fetch/profiles';
import {
  list as listAffiliations,
  create,
  save,
  renew,
  removeAffiliation,
  removePayment,
  invoice,
} from '../../../lib/fetch/affiliations';
import { useLoading } from '../../../commons/Loading';
import { useAuth } from '../../../commons/Auth';

const Affiliations = (props) => {
  const [{ newToken } = {}] = useAuth();
  const [affiliations, setAffiliations] = useState([]);
  const alert = useAlert();
  const [t] = useTranslation('DEALS');
  const { showLoading, hideLoading } = useLoading();

  useEffect(() => {
    fetchAffiliations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchAffiliations = async () => {
    showLoading();

    const { error, data } = await listAffiliations({
      profileId: props.id,
      newToken,
    });

    if (error) {
      hideLoading();
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    setAffiliations(data);
    hideLoading();
  };

  async function getAdmin5Profiles(value) {
    const { error, data } = await listProfiles({
      search: value,
      type: 'BUILDING_ADMIN_5',
      newToken,
    });

    if (error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    return data;
  }

  async function getCommercialProfiles(value) {
    const { error, data } = await listProfiles({
      search: value,
      type: 'COMMERCIAL',
      newToken,
    });

    if (error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    return data.filter((elem) => elem._id !== props.id);
  }

  async function createAffiliation(data) {
    showLoading();

    const { error, data: affiliation } = await create({ data, newToken });

    if (error) {
      hideLoading();

      alert.error(
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
          t('COMMON:GENERIC_ERROR')
      );

      return;
    }

    setAffiliations([affiliation, ...affiliations]);
    hideLoading();
    alert.success(t('COMMON:SUCCESS_CREATE'));
  }

  async function updateAffiliation({ id, data }) {
    showLoading();

    const { error } = await save({ id, data, newToken });

    if (error) {
      hideLoading();

      alert.error(
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
          t('COMMON:GENERIC_ERROR')
      );
      throw error;
    }

    fetchAffiliations();
    alert.success(t('COMMON:SUCCESS_UPDATE'));
  }

  async function renewAffiliation({ id }) {
    showLoading();

    const { error } = await renew({ id, newToken });

    if (error) {
      hideLoading();

      alert.error(
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
          t('COMMON:GENERIC_ERROR')
      );

      return;
    }

    fetchAffiliations();
    alert.success(t('COMMON:SUCCESS_RENEW'));
  }

  async function deleteAffiliation(id) {
    showLoading();

    const { error } = await removeAffiliation({ id, newToken });

    if (error) {
      hideLoading();

      alert.error(
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
          t('COMMON:GENERIC_ERROR')
      );

      return;
    }

    fetchAffiliations();
    alert.success(t('COMMON:SUCCESS_DELETE'));
  }

  async function deletePayment(affiliationId, paymentIndex) {
    showLoading();

    const { error } = await removePayment({
      affiliationId,
      paymentIndex,
      newToken,
    });

    if (error) {
      hideLoading();

      alert.error(
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
          t('COMMON:GENERIC_ERROR')
      );

      return;
    }

    fetchAffiliations();
    alert.success(t('COMMON:SUCCESS_DELETE'));
  }

  async function invoiceAffiliation(affiliationId, totalNet) {
    showLoading();

    const { error } = await invoice({
      newToken,
      affiliationId,
      totalNet,
    });

    if (error) {
      hideLoading();
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    fetchAffiliations();
    hideLoading();
  }

  return (
    <AffiliationsPresentational
      createAffiliation={createAffiliation}
      updateAffiliation={updateAffiliation}
      affiliations={affiliations}
      getAdmin5Profiles={getAdmin5Profiles}
      getCommercialProfiles={getCommercialProfiles}
      renewAffiliation={renewAffiliation}
      deleteAffiliation={deleteAffiliation}
      deletePayment={deletePayment}
      invoiceAffiliation={invoiceAffiliation}
      onStatusChanged={() => fetchAffiliations()}
      {...props}
    />
  );
};

export default Affiliations;
